import React from 'react'
import PropTypes from 'prop-types'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import InboxIcon from 'material-ui-icons/Inbox'
import {withStyles} from 'material-ui/styles/index'
import withWidth from 'material-ui/utils/withWidth'
import styles from '../styles'
import compose from 'recompose/compose'

import {catalog as text} from '../text'
import {signup as signupText, business as businessText} from '../../../common/text'
import Container from '../../../common/components/Container'
import ObjectList from '../../../common/components/ObjectList'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Title from './title'
import CategoryList from '../containers/categoryList'

import InfiniteScroll from '../../../common/components/InfiniteScroll'

class Yours extends React.Component {

  state = {
    isOpen: false,
  }

  tileClick = id => {
    this.props.history.push('/objetos/' + id)
  }

  handleLoginClick = () => {
    this.props.history.push('/registrarse')
  }

  handleStoreClick = () => {
    this.setState({
      isOpen: true,
    })
  }

  loadMore = () => {
    const amount = 8
    this.props.setOffset(this.props.offset + amount)
    this.props.setLimit(amount)
    this.props.search()
  }

  renderNotLoggedInMessage = ({classes}) => (
    <Container>
      <div className={classes.messageWrapper}>
        <Typography variant="display2" gutterBottom>{text.notLoggedInMessage.title}</Typography>
        <InboxIcon className={classes.messageIcon}/>
        <Typography variant="body1" gutterBottom className={classes.messageBody}>
          {text.notLoggedInMessage.body}
        </Typography>
        <Button variant="raised" color="primary" onClick={this.handleLoginClick}>{signupText.button}</Button>
      </div>
    </Container>
  )

  renderNoObjectsMessage = ({classes}) => (
    <div className={classes.messageWrapper}>
      <Typography variant="display2" gutterBottom>{text.noObjectsMessage.body}</Typography>
    </div>
  )

  render() {
    const {isLoggedIn, items, width, isSearching, isDirty, expectMore} = this.props
    if (isLoggedIn === false)
      return this.renderNotLoggedInMessage(this.props)
    if (isDirty === false && isSearching === false && items.length === 0)
      return this.renderNoObjectsMessage(this.props)

    return (
      <Container>
        <InfiniteScroll shouldTrigger={isSearching === false && expectMore === true} trigger={this.loadMore}>
        <HeaderProgress show={isSearching}/>
        <Title gutterBottom={true}>{businessText.categories}</Title>
        <CategoryList/>
        <Title gutterBottom={true}>{businessText.catalog}</Title>
        <ObjectList
          items={items}
          width={width}
          handleTileClick={this.tileClick}
          showNoObjectsMessage={items.length === 0 && isSearching === false}
        />
        </InfiniteScroll>
      </Container>
    )
  }
}

Yours.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isSearching: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  expectMore: PropTypes.bool,
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Yours)



// WEBPACK FOOTER //
// ./src/sections/catalog/components/catalog.js